<div class="flex flex-wrap">
  <div class="relative w-full xl:w-5/12 authBackground">
    <app-carousel></app-carousel>
  </div>

  <div class="relative w-full xl:w-7/12">
    <div class="login-card">
      <div class="login-main">
        <h4>{{ 'MESSAGES.SUGGESTIONS.LOGIN_TO_YOUR_ACCOUNT' | translate: { portalId } }}</h4>
        @if(portal?.isMerchant) {
        <p>{{ 'LOGIN.EMAIL_OR_MOBILE_SIGN_IN1' | translate }}</p>
        } @else {
        <p>{{ 'LOGIN.EMAIL_OR_MOBILE_SIGN_IN2' | translate }}</p>
        }

        <app-login-identity
          [portal]="portal"
          [portalId]="portalId"
          [loginMethod]="loginMethod"
          (identityChange)="identity.set($event)"
        ></app-login-identity>

        @if (loginType === 'pin') {
        <app-login-pin
          [active]="identity().active"
          [incorrectPassword]="incorrectPassword()"
          [errors]="errors()"
          (credentialSubmit)="onCredentialSubmit($event)"
          (dismissIncorrectPassword)="incorrectPassword.set(false)"
          (clearErrors)="clearErrors()"
        ></app-login-pin>
        } @else {
        <app-login-password
          [active]="identity().active"
          [incorrectPassword]="incorrectPassword()"
          (credentialSubmit)="onCredentialSubmit($event)"
          (dismissIncorrectPassword)="incorrectPassword.set(false)"
        ></app-login-password>
        }

        <p class="mt-6 mb-0">
          {{ (loginType === 'pin' ? 'LOGIN.FORGOT_PIN' : 'LOGIN.FORGOT_PASSWORD') | translate }}
          <a [routerLink]="link.forgotPassword" id="resetPasswordLink">Reset it.</a>
        </p>

        @if (isAllowedToCreateAccount) {
        <p class="mb-0">
          {{ 'MESSAGES.PROMPTS.DONT_HAVE_ACCOUNT_YET' | translate }}
          <a [routerLink]="link.register" class="ml-1" id="createAccountLink"
            >{{ 'MESSAGES.SUGGESTIONS.CREATE_AN_ACCOUNT' | translate }}</a
          >
        </p>
        }
      </div>
    </div>
  </div>
</div>
